import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getLabel } from '../../../../utils/string';

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
/**
 * Outputs rating elements for a DisplayItem.
 *
 * @namespace
 * @memberOf Common.Components.DisplayItems.Elements
 *
 * @prop rating:    {integer} Rating value
 * @prop range:     {integer} Max range of ratings
 * @prop likes:     {integer} Likes value
 */
class ItemRating extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="xMetaContainer xMetaRating xHoverHide">
        <p className="xMeta xRatingIcons">
          <For each="rating" index="idx" of={_.range(1, this.props.range + 1)}>
            <i key={idx} data-alt={idx} className={idx < this.props.rating ? 'star-on-png' : 'star-off-png'}/>
          </For>
        </p>
        <p className="xMeta xRatingText">
          <span className="xRatingScore">{this.props.rating}</span>
          <span className="xRatingSeparator">/</span>
          <span className="xRatingTotal">{this.props.range}</span>
        </p>
        <If condition={!!this.props.likes}>
          <p className="xMeta xRatingLikes">{this.props.likes} {this.props.likesLabel}</p>
        </If>
      </div>
    )
  }
}


//  TODO pass in label from parent.  Currently referenced from NGX global
ItemRating.propTypes = {
  rating:     PropTypes.number.isRequired,
  range:      PropTypes.number.isRequired,
  likes:      PropTypes.number,
  likesLabel: PropTypes.string
}

ItemRating.defaultProps = {
  likesLabel: 'Likes'
}

export default ItemRating;
